import { makeStyles } from "@material-ui/core/styles";

/**
 * Estilos de botões de ação reutilizáveis no kanban e popovers.
 * Tudo puxa do design system global (theme.chatiaDS) — funciona em
 * dark/light mode automaticamente.
 */
const useActionBtnStyles = makeStyles((theme) => {
  const ds = theme.chatiaDS || {};
  const colors = ds.colors || {};
  const radius = ds.radius || { sm: 10, md: 12 };
  const isDark = theme.mode === "dark" || theme.palette?.type === "dark";

  return {
    dialogBtn: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "8px 14px",
      borderRadius: radius.md,
      border: "1px solid transparent",
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText || "#fff",
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
      transition: "filter 0.15s",
      "&:hover": { filter: "brightness(0.95)" },
      "&:disabled": { opacity: 0.55, cursor: "not-allowed" },
    },
    actionBtn: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "8px 16px",
      borderRadius: radius.md,
      border: "1px solid transparent",
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText || "#fff",
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: isDark
        ? "0 2px 8px rgba(0,0,0,0.35)"
        : "0 2px 8px rgba(0,0,0,0.08)",
      transition: "filter 0.15s, box-shadow 0.15s",
      "&:hover": {
        filter: "brightness(1.05)",
        boxShadow: isDark
          ? "0 3px 12px rgba(0,0,0,0.45)"
          : "0 3px 12px rgba(0,0,0,0.12)",
      },
      "&:disabled": { opacity: 0.55, cursor: "not-allowed" },
    },
    iconBtn: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 30,
      height: 30,
      padding: 0,
      borderRadius: radius.sm,
      border: "1px solid transparent",
      background: "transparent",
      color: colors.textPrimary || (isDark ? "#e9edef" : "#111b21"),
      cursor: "pointer",
      transition: "background 0.15s, color 0.15s",
      "&:hover": {
        background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
      },
    },
    iconBtnDelete: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 26,
      height: 26,
      padding: 0,
      borderRadius: radius.sm,
      border: "none",
      background: "rgba(255, 255, 255, 0.06)",
      color: "#e53935",
      cursor: "pointer",
      transition: "background 0.15s, color 0.15s",
      "&:hover": {
        background: "rgba(244, 67, 54, 0.18)",
        color: "#c62828",
      },
    },
    // Mesmo formato do delete, mas em primary (não vermelho).
    iconBtnEdit: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 26,
      height: 26,
      padding: 0,
      borderRadius: radius.sm,
      border: "none",
      background: `color-mix(in srgb, ${theme.palette.primary.main} 12%, transparent)`,
      color: theme.palette.primary.main,
      cursor: "pointer",
      transition: "background 0.15s, color 0.15s, filter 0.15s",
      "&:hover": {
        background: `color-mix(in srgb, ${theme.palette.primary.main} 22%, transparent)`,
        filter: "brightness(0.95)",
      },
    },
    iconBtnPrimary: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 30,
      height: 30,
      padding: 0,
      borderRadius: radius.sm,
      border: "none",
      background: "rgba(25, 118, 210, 0.1)",
      color: theme.palette.primary.main,
      cursor: "pointer",
      transition: "background 0.15s",
      "&:hover": { background: "rgba(25, 118, 210, 0.2)" },
    },
    ghostBtn: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 12px",
      borderRadius: radius.md,
      border: `1px solid ${colors.border || (isDark ? "#374454" : "#e2e8f0")}`,
      background: "transparent",
      color: colors.textPrimary || (isDark ? "#e9edef" : "#111b21"),
      fontSize: 12,
      fontWeight: 500,
      cursor: "pointer",
      transition: "background 0.15s",
      "&:hover": {
        background: isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)",
      },
    },
  };
});

export default useActionBtnStyles;
